import React from "react";
import Navbar from "./Component/Navbar";
import Page11 from "./Component/Footer";
import { Outlet } from "react-router-dom";
import Footer from "./Component/Footer";
import { Container } from "reactstrap";
import "../../Homepage/Component/Homepage.css";
import MenuService from "../../services/MenuService";
import { useQuery } from "@tanstack/react-query";

const MainLayout = ({ children }) => {
  const { isLoading, error, data } = useQuery({
    queryKey: ["menu-list"],
    queryFn: () => MenuService.getList(),
  });



  // Filter by menuTypeName === "header"
  // const footerMenus =
  //   data?.filter((menu) => menu.menuTypeName === "Footer") || [];
  // const headerMenus =
  //   data?.filter((menu) => menu.menuTypeName === "Header") || [];
  // console.log("🚀 ~ MainLayout ~ headerMenus:", headerMenus)

  const headerMenus =
    data?.filter((menu) =>
      menu.menuTypes?.some((mt) => mt.name === "Onshore-Header")
    ) || [];

  const intelligenceMenus =
    data?.filter((menu) =>
      menu.menuTypes?.some((mt) => mt.slug === "onshore-header")
    ) || [];

  const footerMenus =
    data?.filter((menu) =>
      menu.menuTypes?.some((mt) => mt.name === "Footer")
    ) || [];

  return (
    <div>
      <Navbar headerMenus={headerMenus} />
      <main>
        <Outlet /> {/* This renders the child route */}
      </main>
      <Container fluid style={{ background: "#7D178F" }}>
        <Container
          style={{
            width: window.innerWidth < 500 ? "100%" : "75%",
          }}
        >
          <Footer footerMenus={footerMenus} />
        </Container>
      </Container>
    </div>
  );
};

export default MainLayout;
